import React from "react";
import {
  Container,
  Box,
  Typography,
  Button,
  Grid,
  Paper,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const Home: React.FC = () => {
  return (
    <>
      {/* Hero Section */}
      <Box
        py={4}
        sx={{
          bgcolor: "#101010",
          color: "#FFFFFF",
          textAlign: "center",
          userSelect: 'none'
        }}
      >
        <Container maxWidth="lg">
          <Box maxWidth="sm" mx="auto">
            <Box mb={3}>
              <img
                src="/images/logo-main.png"
                alt="Shop Logo"
                style={{ maxWidth: "340px", height: "auto" }}
              />
            </Box>
            <Typography variant="subtitle1" paragraph sx={{ color: "#C0C0C0" }}>
              Your community hub for collecting, trading, and celebrating the world of trading cards.
            </Typography>
            <Button
              variant="contained"
              size="large"
              sx={{
                bgcolor: "#89C7C8",
                color: "#1E1E2F",
                fontWeight: "bold",
                "&:hover": { bgcolor: "#76b3b4" },
              }}
              onClick={() => {
                const el = document.getElementById("social");
                if (el) {
                  el.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              Shop Updates
            </Button>
          </Box>
        </Container>
      </Box>

      {/* Featured Categories */}
      <Box
        sx={{
          bgcolor: "#1E1E2F",
          py: 8,
        }}
      >
        <Container maxWidth="lg">
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{
              color: "#e0e0e0",
              fontWeight: 600,
              mb: 4,
            }}
          >
            Games
          </Typography>
         <Typography
            variant="subtitle1"
            align="center"
            sx={{
              color: "#C0C0C0",
              mb: 4,
            }}
          >
           We have everything you need with sealed products, singles, and accessories for all the biggest trading card games and a great selection of sports cards.
          </Typography>

          <Grid container spacing={4}>
            {[
              { src: "pokemon.png" },
              { src: "yugioh.png" },
              { src: "lorcana.png" },
              { src: "onep.png" },
              { src: "dragonball.png" },
              { src: "unionwhite.png" },
              { src: "mtg.png" },
              { src: "digimon.png" },
            ].map((category) => (
              <Grid item xs={12} sm={6} md={3} sx={{ mb: 4 }} key={category.src}>
                <Paper
                  elevation={6}
                  sx={{
                    p: 3,
                    bgcolor: "#242435",
                    borderRadius: 2,
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "background 0.3s",
                    "&:hover": {
                      bgcolor: "#2D2D42",
                    },
                  }}
                >
                  <Box textAlign="center">
                    <img
                      src={`/images/${category.src}`}
                      alt=""
                      style={{ width: "120px", height: "auto" }}
                    />
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default Home;
